import './ReportService.scss';

import { faArrowDownWideShort, faScissors } from '@fortawesome/free-solid-svg-icons';
import { formatDateInEN, formatInReal } from '../../commons/util/HallAppUtil';
import { useEffect, useState } from 'react';

import AppCard from '../../commons/cards/AppCard';
import AppLoading from '../../commons/AppLoading';
import { Button } from 'react-bootstrap';
import EmptyState from '../../commons/EmptyState';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HallAppToast from '../../commons/HallAppToast';
import ReportAPI from '../report/ReportAPI';
import ReportFullFilter from './ReportFullFilter';
import ReportHeader from './components/ReportHeader';

/* eslint-disable react-hooks/exhaustive-deps */
function ReportService() {
  const [isLoadingSummary, setIsLoadingSummary] = useState(true);
  const [reportServices, setReportServices] = useState([]);
  const [orderBy, setOrderBy] = useState('VALUE'); // 'VALUE' | 'QTD_SERVICE'

  const reportAPI = new ReportAPI();

  const today = new Date();
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

  const [filter, setFilter] = useState({
    startDate: formatDateInEN(firstDayOfMonth),
    endDate: formatDateInEN(new Date()),
  });

  useEffect(() => {
    findReportService();
  }, [filter]);

  async function findReportService() {
    try {
      setIsLoadingSummary(true);
      const response = await reportAPI.getReportService(filter);
      const data = response.data || [];
      // Ordena inicialmente por valor (desc)
      const sortedValueDesc = [...data].sort((a, b) => b.totalValue - a.totalValue);
      setReportServices(sortedValueDesc);
      setOrderBy('VALUE'); // reseta ordenação ao buscar novos dados
    } catch (_) {
      HallAppToast.genericError();
      setReportServices([]);
    } finally {
      setIsLoadingSummary(false);
    }
  }

  function changeDates(startDate, endDate) {
    let adjustedEndDate;

    if (endDate === null) {
      const start = new Date(startDate);
      adjustedEndDate = new Date(start.getFullYear(), start.getMonth() + 2, 0);
    } else {
      const end = new Date(endDate);
      adjustedEndDate = new Date(end.getFullYear(), end.getMonth() + 2, 0);
    }

    adjustedEndDate.setHours(0, 0, 0, 0);

    setFilter({
      startDate,
      endDate: formatDateInEN(adjustedEndDate),
    });
  }

  function toggleOrder() {
    let sorted = [];
    if (orderBy === 'VALUE') {
      // Ordena por quantidade de serviços realizados (desc)
      sorted = [...reportServices].sort((a, b) => b.totalRealized - a.totalRealized);
      setOrderBy('QTD_SERVICE');
    } else {
      // Ordena por valor total (desc)
      sorted = [...reportServices].sort((a, b) => b.totalValue - a.totalValue);
      setOrderBy('VALUE');
    }
    setReportServices(sorted);
  }

  const orderLabel = orderBy === 'VALUE' ? 'Ordenar por quantidade' : 'Ordenar por valor';

  return (
    <div className="report-service">
      <ReportHeader name="Relatório por Serviço" />

      <div className="report-service__filter">
        <ReportFullFilter changeDates={changeDates} />
      </div>

      <div className="container pb-5">
        {/* Controle de ordenação */}
        {!isLoadingSummary && reportServices.length > 0 && (
          <div className="report-service__sort">
            <Button
              variant="outline-primary"
              size="sm"
              onClick={toggleOrder}
              aria-label={orderLabel}
              className="d-flex align-items-center gap-2"
            >
              <FontAwesomeIcon icon={faArrowDownWideShort} />
              {orderLabel}
            </Button>
          </div>
        )}

        <hr className="my-3" />

        {isLoadingSummary ? (
          <AppLoading />
        ) : reportServices.length === 0 ? (
          <EmptyState
            title="Nenhum serviço encontrado"
            description="Não há serviços realizados no período selecionado. Ajuste as datas para visualizar outros períodos."
            icon={<FontAwesomeIcon icon={faScissors} />}
          />
        ) : (
          <div className="row g-4 mt-2">
            {reportServices.map((report, index) => (
              <div className="col-12 col-md-6 col-lg-4" key={index}>
                <AppCard className="service-report-card">
                  {/* Badge de ranking (top 3) */}
                  {index < 3 && (
                    <div className={`service-report-card__badge badge-${index + 1}`}>
                      #{index + 1}
                    </div>
                  )}

                  <div className="service-report-card__header">
                    <h6 className="service-report-card__title" title={report?.name}>
                      {report?.name}
                    </h6>
                  </div>

                  <div className="service-report-card__body">
                    <div className="service-report-card__row">
                      <span className="service-report-card__label">Valor total</span>
                      <span className="service-report-card__value service-report-card__value--highlight">
                        {formatInReal(report?.totalValue || 0)}
                      </span>
                    </div>

                    <div className="service-report-card__row">
                      <span className="service-report-card__label">Realizados</span>
                      <span className="service-report-card__value">
                        {report?.totalRealized || 0}
                      </span>
                    </div>
                  </div>
                </AppCard>
              </div>
            ))}
          </div>
        )}
      </div>
      <div style={{ height: "calc(50px + 72px)" }}></div>
    </div>
  );
}

export default ReportService;